import { trpc } from '@/config/trpc';
import useHandleSaveContactError from '@/shared/hooks/useHandleSaveContactError';

const useUpdateContact = () => {
  const handleSaveContactError = useHandleSaveContactError();

  return trpc.contact.update.useMutation({
    onError: handleSaveContactError,
  });
};

export default useUpdateContact;
